import validationUtils from './validationUtils';
import dateUtils from './dateUtils';
import formattingUtils from './formattingUtils';
import arrayUtils from './arrayUtils';
import urlUtils from './urlUtils';
import customerUtils from './customerUtils';
import uiUtils from './uiUtils';

export {
    validationUtils,
    dateUtils,
    formattingUtils,
    arrayUtils,
    urlUtils,
    customerUtils,
    uiUtils
};

const helpers = {
    ...validationUtils,
    ...dateUtils,
    ...formattingUtils,
    ...arrayUtils,
    ...urlUtils,
    ...customerUtils,
    ...uiUtils
};

export default helpers;
